define( [
	"./arr"
], function( arr ) {

"use strict";

return arr.pop;

} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/pop.js
// module id = 113
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21